import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import { format, parse, startOfWeek, getDay } from "date-fns";
import enUS from "date-fns/locale/en-US";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { getEventInstancesForMonth } from "../services/firebase";
import { Box, Typography, CircularProgress } from "@mui/material";

const locales = { "en-US": enUS };
const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

export const EventsCalendar = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentDate, setCurrentDate] = useState(new Date());
  const navigate = useNavigate();

  const fetchEvents = useCallback(async (date) => {
    setLoading(true);
    try {
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // month is 0-indexed
      const fetchedInstances = await getEventInstancesForMonth(year, month);

      const calendarEvents = fetchedInstances.map((instance) => {
        const eventData = instance.event || {}; // Handle cases where event data might be missing
        return {
          id: instance.id,
          title: eventData.name || "Untitled Event",
          start: instance.startDate.toDate(),
          end: instance.endDate.toDate(),
          resource: instance, // Store the full instance data for navigation
        };
      });
      setEvents(calendarEvents);
    } catch (error) {
      console.error("Failed to fetch events:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchEvents(currentDate);
  }, [fetchEvents, currentDate]);

  const handleNavigate = (newDate) => {
    setCurrentDate(newDate);
  };

  const handleSelectEvent = (event) => {
    if (event.resource && event.resource.eventId) {
      navigate(`/events/${event.resource.eventId}`);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Events Calendar
      </Typography>
      <Box sx={{ height: "70vh" }}>
        <Calendar
          localizer={localizer}
          events={events}
          startAccessor="start"
          endAccessor="end"
          style={{ height: "100%" }}
          onNavigate={handleNavigate}
          onSelectEvent={handleSelectEvent}
          date={currentDate} // Control the displayed date
        />
      </Box>
    </Box>
  );
};
